<!-- Hero Section -->
<section class="hero-section" role="banner">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <h1 class="hero-title">Servicios de Punta a Punta</h1>
        <p class="hero-description">
          Mapeo de talento, formación, rediseño de puestos, cultura inclusiva y métricas de impacto. 
          Transformamos tu empresa en un lugar de trabajo verdaderamente inclusivo.
        </p>
        <div class="hero-stats">
          <div class="stat-item">
            <span class="stat-number">95%</span>
            <span class="stat-label">Tasa de Éxito</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">50+</span>
            <span class="stat-label">Empresas</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">24h</span>
            <span class="stat-label">Respuesta</span>
          </div>
        </div>
        <div class="hero-actions">
          <button class="btn btn-light btn-lg px-4" (click)="agendarDiagnostico()">
            <i class="fas fa-calendar-alt me-2"></i>Agendar diagnóstico
          </button>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="hero-image">
          <img src="assets/images/servicios.png" alt="Servicios empresariales" class="img-fluid">
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Main Content -->
<main>
  <!-- Servicios con Tabs -->
  <section class="servicios-tabs">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">Nuestros Servicios</h2>
        <p class="section-description">
          Soluciones integrales diseñadas para transformar tu empresa en un lugar de trabajo verdaderamente inclusivo y diverso
        </p>
      </div>
      
      <!-- Tabs de navegación -->
      <ul class="nav nav-tabs justify-content-center mb-4" id="serviciosTabs" role="tablist">
        <li class="nav-item" role="presentation" *ngFor="let servicio of servicios; let i = index">
          <button 
            class="nav-link" 
            [class.active]="tabActivo === i"
            [id]="servicio.id + '-tab'"
            data-toggle="tab" 
            [attr.data-target]="'#' + servicio.id" 
            type="button" 
            role="tab"
            (click)="cambiarTab(i)"
          >
            <i [class]="servicio.icono + ' me-2'"></i>{{ servicio.titulo }}
          </button>
        </li>
      </ul>

      <!-- Contenido de los tabs -->
      <div class="tab-content" id="serviciosTabContent">
        <div 
          class="tab-pane fade" 
          [class.show]="tabActivo === i"
          [class.active]="tabActivo === i"
          [id]="servicio.id" 
          role="tabpanel" 
          *ngFor="let servicio of servicios; let i = index"
        >
          <div class="row">
            <div class="col-lg-8">
              <div class="card service-card">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-4">
                    <div class="service-icon">
                      <i [class]="servicio.icono"></i>
                    </div>
                    <div>
                      <h3 class="mb-1">{{ servicio.titulo }}</h3>
                      <p class="text-muted mb-0">SLA: {{ servicio.sla }}</p>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col-md-6">
                      <h5 class="mb-3">Entregables</h5>
                      <ul class="list-unstyled entregables-list">
                        <li *ngFor="let entregable of servicio.entregables">
                          <i class="fas fa-check text-success me-2"></i>{{ entregable }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-6">
                      <h5 class="mb-3">KPIs Prometidos</h5>
                      <ul class="list-unstyled kpis-list">
                        <li *ngFor="let kpi of servicio.kpis">
                          <i class="fas fa-chart-line text-primary me-2"></i>{{ kpi }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  
                  <div class="text-center mt-4">
                    <button class="btn btn-primary btn-lg" (click)="agendarDiagnostico()">
                      <i class="fas fa-calendar-alt me-2"></i>Agendar diagnóstico
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="card border-0 bg-light">
                <div class="card-body">
                  <h5 class="card-title">¿Por qué elegirnos?</h5>
                  <ul class="list-unstyled">
                    <li class="mb-2">
                      <i class="fas fa-star text-warning me-2"></i>Especialistas certificados
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-clock text-info me-2"></i>Respuesta en 24h
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-shield-alt text-success me-2"></i>Garantía de resultados
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Comparador -->
  <section class="comparador-section py-5 bg-light" id="comparacion">
    <div class="container">
      <h2 class="text-center mb-5">Lo que hacemos diferente</h2>
      <div class="table-responsive">
        <table class="table table-striped table-hover comparison-table">
          <thead class="table-dark">
            <tr>
              <th scope="col">Aspecto</th>
              <th scope="col">Hacerlo solo</th>
              <th scope="col">Con IncluTec</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of comparacion">
              <td><strong>{{ item.aspecto }}</strong></td>
              <td>{{ item.solo }}</td>
              <td class="table-success">
                <i class="fas fa-check-circle text-success me-2"></i>{{ item.inclutec }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <!-- Paquetes/Bundles -->
  <section class="paquetes-section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">Nuestros Paquetes</h2>
        <p class="section-description">
          Soluciones adaptadas a diferentes necesidades empresariales con resultados garantizados
        </p>
      </div>
      <div class="row">
        <div class="col-lg-4 mb-4" *ngFor="let paquete of paquetes">
          <div class="card h-100 border-0 shadow-sm" [class.border-primary]="paquete.destacado">
            <div class="card-header text-center" [class.bg-primary]="paquete.destacado" [class.text-white]="paquete.destacado">
              <h4 class="mb-0">{{ paquete.nombre }}</h4>
              <span class="badge bg-warning" *ngIf="paquete.destacado">Más Popular</span>
            </div>
            <div class="card-body">
              <p class="card-text">{{ paquete.descripcion }}</p>
              <div class="text-center mb-3">
                <span class="h3 text-primary">{{ paquete.precio }}</span>
              </div>
              <p class="mb-3"><strong>Cohortes:</strong> {{ paquete.cohortes }}</p>
              
              <h6 class="mb-2">Métricas esperadas:</h6>
              <ul class="list-unstyled">
                <li *ngFor="let metrica of paquete.metricas" class="mb-1">
                  <i class="fas fa-check text-success me-2"></i>{{ metrica }}
                </li>
              </ul>
            </div>
            <div class="card-footer text-center border-0">
              <button class="btn btn-primary w-100" (click)="contactarVentas()">
                <i class="fas fa-phone me-2"></i>Contactar ventas
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Casos de Éxito -->
  <section class="casos-exito-section py-5 bg-light">
    <div class="container">
      <h2 class="text-center mb-5">Casos de Éxito</h2>
      <div class="row">
        <div class="col-lg-6 mb-4" *ngFor="let caso of casosExito">
          <div class="card h-100 border-0 shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div>
                  <h5 class="card-title mb-1">{{ caso.empresa }}</h5>
                  <p class="text-muted mb-0">{{ caso.sector }} • {{ caso.empleados }} empleados</p>
                </div>
                <span class="badge bg-success">Éxito</span>
              </div>
              
              <div class="mb-3">
                <h6 class="fw-bold">Reto:</h6>
                <p class="mb-2">{{ caso.reto }}</p>
                
                <h6 class="fw-bold">Solución:</h6>
                <p class="mb-2">{{ caso.solucion }}</p>
              </div>
              
              <div class="row text-center">
                <div class="col-4">
                  <div class="metric-item">
                    <div class="metric-number text-success">{{ caso.resultados.cumplimiento }}</div>
                    <small class="text-muted">Cumplimiento</small>
                  </div>
                </div>
                <div class="col-4">
                  <div class="metric-item">
                    <div class="metric-number text-primary">{{ caso.resultados.productividad }}</div>
                    <small class="text-muted">Productividad</small>
                  </div>
                </div>
                <div class="col-4">
                  <div class="metric-item">
                    <div class="metric-number text-info">{{ caso.resultados.retencion }}</div>
                    <small class="text-muted">Retención</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA Persistente -->
  <section class="cta-persistente py-5 bg-primary text-white">
    <div class="container">
      <div class="row justify-content-center text-center">
        <div class="col-lg-8">
          <h2 class="mb-4">¿Listo para empezar?</h2>
          <p class="lead mb-4">Únete a las empresas que ya están transformando su cultura y cumpliendo la ley</p>
          <button class="btn btn-light btn-lg px-5" (click)="agendarDiagnostico()">
            <i class="fas fa-rocket me-2"></i>Quiero empezar
          </button>
        </div>
      </div>
    </div>
  </section>
</main>
